import React, { useEffect } from 'react';
// import { shallowEqual, useSelector } from 'react-redux';
import { LoadingDialog } from '../../../../../_metronic/_partials/controls';

export function QueuesLoadingDialog() {
  // Queues Redux state
  // const { isLoading } = useSelector((state) => ({ isLoading: state.queues.listLoading }), shallowEqual);
  const isLoading = false;
  // looking for loading/dispatch
  useEffect(() => {}, [isLoading]);
  return <LoadingDialog isLoading={isLoading} text="Loading ..." />;
}
